import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}

import { required } from '@vuelidate/validators';
import { appsApi } from '@/features/apps/shared/services/apps';
import { CreatePrivateAppViewModel } from '@/features/apps/shared/models';
import Toast from '@/shared/services/toast';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';
import { useRouter } from 'vue-router';
import useVuelidate from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePrivateApp',
  setup(__props) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);

const appName = ref('');
const actionInProgress = ref(false);

const validations = {
  appName: { required },
};

const $v = useVuelidate(validations, { appName });

const router = useRouter();

onBeforeMount(() => {
  if (!currentWorkspace.value) {
    handleSeriousError('No workspace selected');
  }
});

function save() {
  if (actionInProgress.value) {
    return;
  }

  actionInProgress.value = true;

  const request = {
    appName: appName.value,
  } as CreatePrivateAppViewModel;

  appsApi
    .createPrivateApp(currentWorkspace.value.id, request)
    .then((result) => {
      router.push({ name: 'private-apps-edit', params: { id: result.app.id } });
    })
    .catch((err) => Toast.showError(err.message))
    .finally(() => (actionInProgress.value = false));
}

function cancel() {
  router.push({ name: 'private-apps-list' });
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("fieldset", null, [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "App Name", -1)),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { 'is-danger': _unref($v).appName.$invalid && _unref($v).appName.$dirty }]),
            type: "text",
            placeholder: "Enter app name here",
            required: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((appName).value = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref($v).appName.$touch()))
          }, null, 34), [
            [
              _vModelText,
              appName.value,
              void 0,
              { trim: true }
            ]
          ]),
          (_unref($v).appName.$invalid && _unref($v).appName.$dirty)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "The app name is required"))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (save())),
            disabled: _unref($v).$invalid,
            loading: actionInProgress.value
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Submit")
            ])),
            _: 1
          }, 8, ["disabled", "loading"]),
          _createVNode(_component_n_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel())),
            variant: "primary--outline"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Cancel")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})